import React from 'react';
import { SocialIcon } from '@jobmatchme/ui';
import facebookIcon from './icons/facebook.svg';
import instaIcon from './icons/instagram.svg';
import linkedinIcon from './icons/linkedin.svg';
import twitterIcon from './icons/twitter.svg';
import xingIcon from './icons/xing.svg';
import youtubeIcon from './icons/youtube.svg';
/**
 * A static array of social buttons
 *
 **/

export var SocialBar = function SocialBar() {
  return React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, React.createElement(SocialIcon, {
    url: "https://www.facebook.com/TruckJobsDeutschland",
    title: "FB",
    src: facebookIcon
  }), React.createElement(SocialIcon, {
    url: "https://www.instagram.com/truckjobs/",
    title: "Instagram",
    src: instaIcon
  }), React.createElement(SocialIcon, {
    url: "https://twitter.com/TruckJobsDE",
    title: "Twitter",
    src: twitterIcon
  }), React.createElement(SocialIcon, {
    url: "https://www.linkedin.com/company/jobmatchme",
    title: "Linkedin",
    src: linkedinIcon
  }), React.createElement(SocialIcon, {
    url: "https://www.youtube.com/channel/UCHFdj8Q4rmlHiDnPQmWci-g/featured",
    title: "Youtube",
    src: youtubeIcon
  }), React.createElement(SocialIcon, {
    url: "https://www.xing.com/companies/jobmatchmegmbh?sc_o=da980_e",
    title: "Xing",
    src: xingIcon
  }));
};
export default SocialBar;